import type { Feed } from '@knocklabs/client'
import { invariant } from '@seen/core/invariant'
import { useContext } from 'react'
import { KnockInboxFeedContext } from '#src/contexts/KnockFeedClientContext.tsx'

export function useKnockFeedClient(): Feed {
  const knockFeedClient = useContext(KnockInboxFeedContext)
  invariant(knockFeedClient, 'KnockInboxFeedContext not found')
  return knockFeedClient
}
